import React from 'react';
import styles from './basket-amount.scss';

const BasketAmount = ({ basketItems }) => (
  <React.Fragment>
    <span
      data-test="basket-amount"
      className={basketItems > 0 ? styles.icon : styles.visuallyHidden}
    >
      {basketItems}
    </span>
    <span className={styles.visuallyHidden}>items in Basket</span>
  </React.Fragment>
);

export default BasketAmount;
